import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Head from "../../elements/head/head";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import { useSelector } from "react-redux";
import api from "../../api";
import TextField from "@mui/material/TextField";
import "./send_mail.scss";
import Grid from "@mui/material/Grid";
import { useEffect, useState, useRef } from "react";
import { useMask } from "@react-input/mask";
import Divider from "@mui/material/Divider";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { setUnauthorized } from "../../store/userSelector";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { API_MEDIA } from "../../env";
import Tooltip from "@mui/material/Tooltip";
import Captcha from "../../elements/capcha/capcha";
import { setCaptcha } from "../../store/captchaSelector";

const Item = styled(Box)(({ theme }) => ({
  backgroundColor: theme.color.main,
  padding: theme.spacing(1),
  textAlign: "center",
  alignItems: "center",
  justifyContent: "center",
  color: theme.color.secondary,
}));
const But = styled(Button)(({ theme }) => ({
  backgroundColor: theme.color.body,
  padding: theme.spacing(1),
  textAlign: "center",
  alignItems: "center",
  justifyContent: "center",
  color: theme.color.secondary,
}));

const EmailBody = (send_email) => {
  // console.log("%%%%%%%%%%%%%%%%%%%%%%");
  // console.log(send_email.send_email);
  const captchaSelect = useSelector((state) => state.captchaSelector.captcha);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [message, setMessage] = useState("");

  const [first_name_error, setFirst_name_error] = useState(false);
  const [first_name_error_helper_text, setFirst_name_error_helper_text] =
    useState("");

  const [email_error, setEmail_error] = useState(false);
  const [email_error_helper_text, setEmail_error_helper_text] = useState("");

  const [body_mes_error, setBody_mes_error] = useState(false);
  const [body_mes_error_helper_text, setBody_mes_error_helper_text] =
    useState("");

  const [first_name, setFirst_name] = useState("");
  const [email, setEmail] = useState("");
  const [body_mes, setBody_mes] = useState("");

  const [but_dis, setBut_dis] = useState(false);

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      );
  };

  const Message = () => {
    if (first_name && email && body_mes && captchaSelect) {
      // setBut_dis(false);
      api
        .postMail(first_name, email, body_mes, send_email.send_email)
        .then((response) => {
          setMessage("Ваше письмо успешно отправлено");
          setFirst_name("");
          setEmail("");
          setBut_dis(false);
          setBody_mes("");
          setFirst_name_error(false);
          setEmail_error(false);
          setBody_mes_error(false);
        })
        .catch((error) => {
          console.error("Ошибка сервера:", error.response.data);
        });
    } else {
      // dispatch(setCaptcha(false));
      setFirst_name_error(true);
      setEmail_error(true);
      setBody_mes_error(true);
      // setBut_dis(true);
    }
  };

  const handleChangeFirst_name = (event) => {
    const value = event.target.value;
    setFirst_name(value);
    if (value.length < 2) {
      setFirst_name_error(true);
      setFirst_name_error_helper_text(
        "Имя не должно содержать менее 2 символов.",
      );
    } else if (value.length > 50) {
      setFirst_name_error(true);
      setFirst_name_error_helper_text(
        "Имя не должно содержать более 50 символов.",
      );
    } else {
      setFirst_name_error(false);
      setFirst_name_error_helper_text("");
    }
  };

  const handleChangeBody_mes = (event) => {
    const value = event.target.value;
    setBody_mes(value);
    if (value.length < 2) {
      setBody_mes_error(true);
      setBody_mes_error_helper_text(
        "Поле не должно содержать не менее 2 символов.",
      );
    } else if (value.length > 50) {
      setBody_mes_error(true);
      setBody_mes_error_helper_text(
        "Поле не должно содержать более 500 символов.",
      );
    } else {
      setBody_mes_error(false);
      setBody_mes_error_helper_text("");
    }
  };

  const handleChangeEmail = (event) => {
    const value = event.target.value;
    setEmail(value);
    if (validateEmail(value)) {
      setEmail_error(false);
      setEmail_error_helper_text("");
    } else {
      setEmail_error(true);
      setEmail_error_helper_text("Некорректное значение Email");
    }
  };

  //   useEffect(() => {
  //     getUser(token);
  //   }, [token]);

  return (
    <div>
      <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
        <Item>
          <TextField
            onChange={handleChangeBody_mes}
            onfo
            id="mail_body"
            label="Текст письма"
            variant="outlined"
            sx={{ width: "100%" }}
            error={body_mes_error}
            value={body_mes}
            slotProps={{ inputLabel: { shrink: true } }}
            multiline
            rows={4}
            helperText={body_mes_error_helper_text}
            required
          />
        </Item>
      </Grid>

      <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
        <Item>
          <TextField
            onChange={handleChangeFirst_name}
            onfo
            id="first_name"
            label="Ваше имя"
            variant="outlined"
            sx={{ width: "100%" }}
            error={first_name_error}
            value={first_name}
            slotProps={{ inputLabel: { shrink: true } }}
            helperText={first_name_error_helper_text}
            required
          />
        </Item>
      </Grid>

      <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
        <Item>
          <TextField
            value={email}
            onChange={handleChangeEmail}
            onfo
            id="email"
            label="Ваш Емаил"
            variant="outlined"
            sx={{ width: "100%" }}
            error={email_error}
            type="email"
            slotProps={{ inputLabel: { shrink: true } }}
            required
            helperText={email_error_helper_text}
          />
        </Item>
      </Grid>

      <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
        <Item>
          <Divider>ОТПРАВКА ДАННЫХ</Divider>
        </Item>
      </Grid>

      <Grid container spacing={1}>
        <Captcha />
      </Grid>

      <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
        <Item>
          <Tooltip title="Нажмите для отправки письма">
            <But
              disabled={but_dis}
              variant="outlined"
              onClick={() => Message()}
            >
              Отправить письмо
            </But>
          </Tooltip>
        </Item>

        <Item>{message}</Item>
      </Grid>
      {/* </Grid> */}
    </div>
  );
};

export default EmailBody;
